import { FC, ReactNode, useRef, useState } from 'react'
import Swiper from 'swiper'
import { SwiperSlide } from 'swiper/react'

import { ScreenSize } from 'styles/mq'
import { Navigation } from './navigation'
import { Preview } from './preview'
import { SliderContainer, StyledSwiper } from './styled'

type Props = {
  slides: Array<{
    component: ReactNode
    title: string
    description?: ReactNode
    link?: string
  }>
  smallTitleSpacing?: boolean
  titleInNav?: boolean
}

export const Slider: FC<Props> = ({
  slides,
  titleInNav,
  smallTitleSpacing,
}) => {
  const swiper = useRef<Swiper>()
  const [slideIndex, setSlideIndex] = useState(0)
  const [openImageUrl, setOpenImageUrl] = useState('')

  return (
    <SliderContainer>
      <StyledSwiper
        loop
        centeredSlides
        slidesPerView="auto"
        spaceBetween={8}
        onTransitionStart={s => setSlideIndex(s.realIndex)}
        onInit={s => {
          swiper.current = s
        }}
        breakpoints={{
          [ScreenSize.MD]: {
            spaceBetween: 20,
          },
        }}
      >
        {slides.map((s, i) => (
          <SwiperSlide key={i}>{s.component}</SwiperSlide>
        ))}
      </StyledSwiper>

      <Navigation
        smallTitleSpacing={smallTitleSpacing}
        titleInNav={titleInNav}
        title={slides[slideIndex].title}
        description={slides[slideIndex].description}
        swiper={swiper}
      />

      <Preview
        openImageUrl={openImageUrl}
        onClose={() => setOpenImageUrl('')}
      />
    </SliderContainer>
  )
}
